// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Layout_wrap__18GLS","content":"Layout_content__hISvs"};